import {
  notification
} from "antd";

export function FetchPost(path, body, callback) {
  let path1 = path.startsWith("http") ? path : window.PROPS.serverPath + path;
  console.log(path1,7)
  fetch(path1, {
      method: "get",
      mode: "cors",
      // body: JSON.stringify(body),
      headers: {
        "Content-type": "application/json; charset=UTF-8",
      },
    })
    .catch((e) => {
      console.log(e);
    })
    .then((response) => (response && response.json()))
    .then((data) => {
      console.log(data, 25)
      if (data.errorCode !== "0" && data.errorCode !== "10160021") {
        console.log(JSON.stringify(data));
        // openNotification("topRight", data.errorMsg);
      }
      callback(data);
    });
}

const openNotification = (placement, errorMsg) => {
  notification.info({
    message: `Notification ${placement}`,
    description: errorMsg,
    placement,
    duration: 3,
  });
};